/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { modalCloseAll } from '../../../modal/modalActions';
import {
    onboardingDisableAllAction,
    onboardingModalViewedAction,
    onboardingShowLaterAction,
    onboardingSkipAction,
    onboardingStartAction,
} from '../../onboardingActions';
import { EOnboardingModalId } from '../../types/onboardingTypes';

export const useOnboardingModal = (id: EOnboardingModalId) => {

    const dispatch = useDispatch();

    const nextStep = useCallback(() => {
        dispatch(onboardingStartAction());
        dispatch(modalCloseAll());
        dispatch(onboardingModalViewedAction({ id }));
    }, [dispatch, id]);

    const showLater = useCallback(() => {
        dispatch(modalCloseAll());
        dispatch(onboardingShowLaterAction());
    }, [dispatch]);

    const skip = useCallback(() => {
        dispatch(modalCloseAll());
        dispatch(onboardingSkipAction());
        dispatch(onboardingModalViewedAction({ id }));
        dispatch(onboardingDisableAllAction());
    }, [dispatch, id]);

    return {
        nextStep,
        showLater,
        skip,
    };
};
